import React from 'react';
import UIComponent from './ui_component.js';
import { withStyles } from 'material-ui/styles';
import { LinearProgress } from 'material-ui/Progress';

const styles = [{
}];

class UILoadingBar extends UIComponent {
  constructor() {
    super();
    this.state = {
      loading: false,
    }
  }

  getDefaults(){
    const defaults = {
      className: '',
    }    
    return defaults;
  }
  
  componentDidMount(){
    const $this = this;

    if(this.props.server){
      this.props.server.onStartLoading = function(){
        $this.setState({loading: true});
      }
      this.props.server.onStopLoading = function(){
        $this.setState({loading: false});
      }
      this.props.server.onError = function(err){
        $this.setState({loading: false});
      }
    }
  }

  render() {
    return (
      <div className={this.props.className}>
        {this.state.loading &&
          <LinearProgress className={this.props.className} color='accent'/>
        }
      </div>
    );
  }
}

export default withStyles(styles)(UILoadingBar);


// WEBPACK FOOTER //
// ./src/core/ui/loading_bar.js